import {useRef, useState} from "react";
import {motion} from "framer-motion";
import styles from './Hero.module.css';

const sushiImg = "https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681d4236fe62be88ec01701c_SearedSalmon.png";
const outlineImg = "https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681bbbbab52926bbdc7aa68d_Button%20Outline.svg";

export default function Hero() {
    const btnRef = useRef(null);
    const [btnPos, setBtnPos] = useState({x: 0, y: 0});

    function handleMouseMove(e) {
        const rect = btnRef.current.getBoundingClientRect();
        setBtnPos({
            x: e.clientX - rect.left, y: e.clientY - rect.top,
        });
    }

    return (
        <section className={styles.heroSection}>
            {/* Sushi top-right */}
            <motion.img
                src={sushiImg}
                alt="Nigiri seared salmon"
                initial={{opacity: 0, y: -40, x: 0}}
                animate={{opacity: 1, y: 50, x: 0}}
                transition={{duration: 0.8, delay: 0.15}}
                className={styles.sushiImage}
                draggable={false}
            />

            <div className={styles.contentWrapper}>
                {/* Headline */}
                <motion.h1
                    initial={{opacity: 0, y: 60, scale: 0.98}}
                    animate={{opacity: 1, y: 0, scale: 1}}
                    transition={{duration: 0.75, ease: [0.23, 1, 0.32, 1]}}
                    className={styles.headline}
                >
                    Sushi<br/>Redefined
                </motion.h1>

                {/* Subtitle directly under title */}
                <motion.p
                    initial={{opacity: 0, y: 30}}
                    animate={{opacity: 1, y: 0}}
                    transition={{duration: 0.8, delay: 0.5}}
                    className={styles.subtitle}
                >
                    At Asahi, it's clean cuts, bold twists,<br/>and flavors for the bold.
                </motion.p>

                {/* Book a table button, bottom right */}
                <motion.a
                    href="/order"
                    ref={btnRef}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={() => setBtnPos({x: 0, y: 0})}
                    initial={{opacity: 0, x: 60, y: 40}}
                    animate={{opacity: 1, x: 0, y: 0}}
                    transition={{duration: 0.8, delay: 0.7}}
                    className={styles.bookTableButton}
                >
                    {/* SVG border */}
                    <img
                        src={outlineImg}
                        alt="Button Outline"
                        className={styles.buttonOutline}
                        draggable={false}
                        style={{
                            transform: btnPos.x ? `scale(1.09) translate(${(btnPos.x - 165) * 0.03}px, ${(btnPos.y - 66) * 0.06}px)` : 'none',
                        }}
                    />
                    {/* Centered text with underline */}
                    <span className={styles.buttonText}>
                        <span>Order Now<span className={styles.underline}></span></span>
                    </span>
                </motion.a>

            </div>
        </section>);
}
